import { Link } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'

/**
 * Sticky back crumb — the way back stays visible however far you scroll.
 * `onBack` takes over the tap (the Session Builder steps BACK through the
 * history rather than opening `to` as a new screen); `to` stays the link's
 * address.
 */
export default function BackBar({ to, label, onBack }) {
  return (
    <div className="sticky top-0 z-20 -mx-4 -mt-4 bg-grouped/95 px-4 pb-2 pt-3 backdrop-blur md:-mx-10 md:-mt-10 md:px-10 md:pt-6">
      <Link
        to={to}
        onClick={onBack ? (e) => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); onBack() } : undefined}
        className="tap inline-flex items-center gap-1 text-sm text-link"
      >
        <ChevronLeft size={16} /> {label}
      </Link>
    </div>
  )
}
